import { render } from "./DepartmentsTable.vue?vue&type=template&id=187cfd9a&scoped=true"
import script from "./DepartmentsTable.vue?vue&type=script&lang=js"
export * from "./DepartmentsTable.vue?vue&type=script&lang=js"

import "./DepartmentsTable.vue?vue&type=style&index=0&id=187cfd9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187cfd9a"]])

export default __exports__